import { ExternalLinkIcon } from 'lucide-react'

import { assets } from '@/ui/assets'
import { ExternalLinkButton } from '@/ui/atoms/link-button/LinkButton'
import { Panel } from '@/ui/atoms/panel/Panel'
import { links } from '@/ui/constants/links'
import { Info } from '@/ui/molecules/info/Info'
import { cn } from '@/ui/utils/style'

export interface HelloSpkBannerProps {
  className?: string
}

export function HelloSpkBanner({ className }: HelloSpkBannerProps) {
  return (
    <Panel
      spacing="none"
      className={cn('relative isolate flex flex-col gap-3 overflow-hidden rounded-md bg-primary-inverse', className)}
    >
      <img
        src={assets.spkAirdrop.helloSpkPanelBg}
        className="absolute top-0 left-0 z-[-1] w-full"
        alt="Hello SPK Token panel background"
      />
      <div className="mt-[60%] flex flex-col gap-6 p-3 text-center sm:gap-10 sm:p-4 md:p-6">
        <div className="flex flex-col gap-2">
          <div className="typography-heading-3 text-primary-inverse">Meet SPK.</div>
          <div className="typography-body-3 text-tertiary">
            The only{' '}
            <span className="mr-0.5 inline-flex items-center gap-0.5">
              top 5{' '}
              <Info className="inline text-secondary">
                Spark is in the top 5 protocols by TVL on DeFiLlama with borrowing enabled (June, 2025).
              </Info>
            </span>{' '}
            DeFi protocol without a token—until now. No VCs, just power to the community. Stake to start earning Spark
            Points.
          </div>
        </div>
        <ExternalLinkButton to={links.docs.spkToken} variant="secondary" size="l" className="w-full">
          Learn more <ExternalLinkIcon className="icon-size-sm" />
        </ExternalLinkButton>
      </div>
    </Panel>
  )
}
